import { IconProps } from '.';

const LensIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142912)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 3.25C12.7785 3.25 9.00126 5.15246 6.47899 8.14679L10.9067 15.3921L17.8162 3.27382C17.5462 3.25802 17.274 3.25 17 3.25ZM20.4576 3.68839L16.1279 11.2821L29.4629 11.1837C27.7463 7.51187 24.4549 4.7237 20.4576 3.68839ZM12.3955 17.8283L14.6965 13.7927L19.8791 13.7545L22.3977 18.2878L19.3137 22.5382L15.287 22.56L12.3955 17.8283ZM12.3668 22.5757L4.93058 10.4074C3.85915 12.3647 3.25 14.6112 3.25 17C3.25 19.0015 3.67765 20.9032 4.44657 22.6185L12.3668 22.5757ZM5.89574 25.1107C7.76399 27.6642 10.4917 29.5491 13.653 30.3398L17.4925 25.0481L5.89574 25.1107ZM16.4518 30.7393L23.7371 20.6988L26.9528 26.4871C24.4486 29.1135 20.9154 30.75 17 30.75C16.8164 30.75 16.6337 30.7464 16.4518 30.7393ZM28.6242 24.3478C29.9705 22.2223 30.75 19.7022 30.75 17C30.75 15.8543 30.6099 14.7413 30.3458 13.6773L22.7274 13.7335L28.6242 24.3478ZM0.75 17C0.75 8.02537 8.02537 0.75 17 0.75C25.9746 0.75 33.25 8.02537 33.25 17C33.25 25.9746 25.9746 33.25 17 33.25C8.02537 33.25 0.75 25.9746 0.75 17Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142912">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LensIcon;
